import type { IconData } from '@stacksjs/iconify-core'

export const facebookF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13.355 22v-9.123h3.062l.459-3.555h-3.52v-2.27c0-1.03.285-1.731 1.761-1.731L17 5.32V2.14A25 25 0 0 0 14.257 2c-2.715 0-4.573 1.657-4.573 4.7v2.622h-3.07v3.555h3.07V22z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default facebookF
